import { queryOptions, useQuery } from '@tanstack/react-query';

import { webhooksApi } from '../api/webhooks-api';

import { webhookKeys } from './webhook-keys';

export function webhookEndpointQueryOptions(storeId: string, id: string) {
  return queryOptions({
    queryKey: webhookKeys.detail(storeId, id),
    queryFn: () => webhooksApi.get(storeId, id),
  });
}

export function useWebhookEndpoint(storeId: string, id: string) {
  return useQuery(webhookEndpointQueryOptions(storeId, id));
}
